import { Split } from "./Split/index.js";
import { Strip } from "./Strip/index.js";
const COMPONENT_MAP = {
  split: Split,
  strip: Strip
};
export {
  COMPONENT_MAP
};
